import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name:'valueSuffix',
  standalone:true,
})
export class ValueSuffixPipe implements PipeTransform {
  transform(value:string, ):string {
    switch (value){
      case 'm2':
        return ' m²';
      case 'euro':
        return ' €';
      case 'percent':
        return '%';
      case 'kwh':
        return ' kWh';
      case 'm3':
        return ' m³';
      default:
        return '';
    }
  }
}
